// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EmbeddingsStatusCodeBuf } from '../file/embeddings-status-code-buf.js';
import { LoadStatusCodeBuf } from '../file/load-status-code-buf.js';
import { MetadataExtractionStatusCodeBuf } from '../file/metadata-extraction-status-code-buf.js';
import { MetadataIndexingStatusCodeBuf } from '../file/metadata-indexing-status-code-buf.js';
import { ThumbnailStatusCodeBuf } from '../file/thumbnail-status-code-buf.js';
import { TranscodeStatusCodeBuf } from '../file/transcode-status-code-buf.js';


export class SearchIndexingStatusBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):SearchIndexingStatusBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsSearchIndexingStatusBuf(bb:flatbuffers.ByteBuffer, obj?:SearchIndexingStatusBuf):SearchIndexingStatusBuf {
  return (obj || new SearchIndexingStatusBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsSearchIndexingStatusBuf(bb:flatbuffers.ByteBuffer, obj?:SearchIndexingStatusBuf):SearchIndexingStatusBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new SearchIndexingStatusBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

loadStatus():LoadStatusCodeBuf {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : LoadStatusCodeBuf.Unknown;
}

metadataExtractionStatus():MetadataExtractionStatusCodeBuf {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : MetadataExtractionStatusCodeBuf.Unset;
}

metadataIndexingStatus():MetadataIndexingStatusCodeBuf {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : MetadataIndexingStatusCodeBuf.Unset;
}

thumbnailStatus():ThumbnailStatusCodeBuf {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ThumbnailStatusCodeBuf.Unknown;
}

transcodeStatus():TranscodeStatusCodeBuf {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : TranscodeStatusCodeBuf.Unset;
}

embeddingsStatus():EmbeddingsStatusCodeBuf {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EmbeddingsStatusCodeBuf.Unset;
}

static startSearchIndexingStatusBuf(builder:flatbuffers.Builder) {
  builder.startObject(7);
}

static addLoadStatus(builder:flatbuffers.Builder, loadStatus:LoadStatusCodeBuf) {
  builder.addFieldInt16(1, loadStatus, LoadStatusCodeBuf.Unknown);
}

static addMetadataExtractionStatus(builder:flatbuffers.Builder, metadataExtractionStatus:MetadataExtractionStatusCodeBuf) {
  builder.addFieldInt16(2, metadataExtractionStatus, MetadataExtractionStatusCodeBuf.Unset);
}

static addMetadataIndexingStatus(builder:flatbuffers.Builder, metadataIndexingStatus:MetadataIndexingStatusCodeBuf) {
  builder.addFieldInt16(3, metadataIndexingStatus, MetadataIndexingStatusCodeBuf.Unset);
}

static addThumbnailStatus(builder:flatbuffers.Builder, thumbnailStatus:ThumbnailStatusCodeBuf) {
  builder.addFieldInt16(4, thumbnailStatus, ThumbnailStatusCodeBuf.Unknown);
}

static addTranscodeStatus(builder:flatbuffers.Builder, transcodeStatus:TranscodeStatusCodeBuf) {
  builder.addFieldInt16(5, transcodeStatus, TranscodeStatusCodeBuf.Unset);
}

static addEmbeddingsStatus(builder:flatbuffers.Builder, embeddingsStatus:EmbeddingsStatusCodeBuf) {
  builder.addFieldInt16(6, embeddingsStatus, EmbeddingsStatusCodeBuf.Unset);
}

static endSearchIndexingStatusBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createSearchIndexingStatusBuf(builder:flatbuffers.Builder, loadStatus:LoadStatusCodeBuf, metadataExtractionStatus:MetadataExtractionStatusCodeBuf, metadataIndexingStatus:MetadataIndexingStatusCodeBuf, thumbnailStatus:ThumbnailStatusCodeBuf, transcodeStatus:TranscodeStatusCodeBuf, embeddingsStatus:EmbeddingsStatusCodeBuf):flatbuffers.Offset {
  SearchIndexingStatusBuf.startSearchIndexingStatusBuf(builder);
  SearchIndexingStatusBuf.addLoadStatus(builder, loadStatus);
  SearchIndexingStatusBuf.addMetadataExtractionStatus(builder, metadataExtractionStatus);
  SearchIndexingStatusBuf.addMetadataIndexingStatus(builder, metadataIndexingStatus);
  SearchIndexingStatusBuf.addThumbnailStatus(builder, thumbnailStatus);
  SearchIndexingStatusBuf.addTranscodeStatus(builder, transcodeStatus);
  SearchIndexingStatusBuf.addEmbeddingsStatus(builder, embeddingsStatus);
  return SearchIndexingStatusBuf.endSearchIndexingStatusBuf(builder);
}
}
